<template>
  <v-scale-screen class="screen-container">
    <Background />
    <!-- title -->
    <!-- 设备号 -->
    <p class="device-no">
      <span class="highlight">{{ $t('Monitoring1025.bouyName') }}:</span>
      {{ this.Equipno }}
    </p>
    <!-- 时间 -->
    <p class="time">
      <span class="highlight">{{ $t('Monitoring1025.utcTime') }}:</span>
      {{ currentTime }}
    </p>
    <!-- 时间 -->
    <p class="local-time">
      <span class="highlight">{{ $t('Monitoring1025.currentTime') }}:</span>
      {{ localTime }}
    </p>
    <!-- Meteorological data -->
    <MeteorilogicalData :eqdata="eqdata" />
    <!-- Hydrological data -->
    <HydrologicalData :eqdata="eqdata" :waveData="waveData" />
    <!-- Historical data -->
    <HistoricalData :bdt="bdt" :edt="edt" :historyData="historyData" :roseData="roseData" @refresh="refreshData" />
    <!-- Current speed data  -->
    <CurrentSpeedProfile :adcpdData="adcpdData" />
    <!-- Alarm -->
    <Alarm :warmData="warmData" />
  </v-scale-screen>
</template>
<script>
import Background from './Background.vue'
import MeteorilogicalData from './MeteorilogicalData.vue'
import HydrologicalData from './HydrologicalData.vue'
import HistoricalData from './HistoricalData.vue'
import CurrentSpeedProfile from './CurrentSpeedProfile.vue'
import Alarm from './AlarmData.vue'
import moment from 'moment'
import { bigfloater3 } from '../../service/getData'

export default {
  data() {
    return {
      number: null,
      equipid: null,
      bdt: moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      edt: moment()
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      adcpType: 1, // 1 一个月 2 一周
      screenData: null,
      Equipno: null,
      currentTime: '',
      eqdata: null,
      waveData: null,
      historyData: null,
      roseData: null,
      warmData: null,
      adcpdData: null,
      timer: null,
      localTime: '',
      localTimer: -1,
      isInitial: true
    }
  },
  methods: {
    async getData() {
      let res3 = await bigfloater3(this.equipid, this.number, this.bdt, this.edt, this.adcpType)
      // 设备信息
      let eqdata = JSON.parse(res3.data.AppendData.eqdata)
      if (Array.isArray(eqdata) && eqdata.length > 0) {
        this.eqdata = eqdata[0]
        this.currentTime = this.eqdata['时间']
        if (this.isInitial) {
          this.bdt = moment(this.currentTime, 'YYYY/M/D H:mm:ss')
            .subtract(1, 'days')
            .format('YYYY-MM-DD HH:mm:ss')
          this.edt = this.currentTime
          this.isInitial = false
        }
      }
      // 24小时波浪
      let waveData = JSON.parse(res3.data.AppendData.wave)
      this.waveData = waveData
      // 历史数据
      let eqhistory = JSON.parse(res3.data.AppendData.eqhistory)
      this.historyData = eqhistory
      // 玫瑰图
      let roseData = [
        res3.data.AppendData.eqboxiang1,
        res3.data.AppendData.eqboxiang2,
        res3.data.AppendData.eqboxiang3,
        res3.data.AppendData.eqboxiang4,
        res3.data.AppendData.eqboxiang5,
        res3.data.AppendData.eqboxiang6,
        res3.data.AppendData.eqboxiang7,
        res3.data.AppendData.eqboxiang8,
        res3.data.AppendData.eqboxiang9,
        res3.data.AppendData.eqboxiang10
      ]
      this.roseData = roseData
      // 警报 暂无数据
      let warm = res3.data.AppendData.warm === '""' ? [] : JSON.parse(res3.data.AppendData.warm)
      this.warmData = warm
      // 热力图
      let adcp = JSON.parse(res3.data.AppendData.adcp)
      this.adcpdData = adcp
    },
    refreshData(cbdt1, cedt1) {
      this.bdt = moment(cbdt1).format('YYYY-MM-DD HH:mm:ss')
      this.edt = moment(cedt1).format('YYYY-MM-DD HH:mm:ss')
      this.getData()
    }
  },
  created() {
    this.equipid = this.$route.query.equipid
    window.guiyanaWindKey = this.equipid == '5638' ? 'Wind Speed (m/s)' : 'Wind Speed(m/s)'
    window.guiyanaTempKey = this.equipid == '5638' ? 'Surface Temp (℃)' : 'Surface Temp(℃)'
    if (this.$route.query.Equipno) {
      this.Equipno = this.$route.query.Equipno
      if (this.$route.query.Equipno.indexOf('-') != -1) {
        this.number = this.$route.query.Equipno.split('-')[1]
      } else {
        this.number = this.$route.query.Equipno
      }
    }
    this.localTime = moment().format('YYYY/M/D H:mm:ss')
    this.localTimer = setInterval(() => {
      this.localTime = moment().format('YYYY/M/D H:mm:ss')
    }, 1000)
  },
  mounted() {
    this.getData()
    this.timer = setInterval(() => {
      this.getData()
    }, 300000)
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.localTimer)
    this.localTimer = null
  },
  components: { Background, MeteorilogicalData, HydrologicalData, HistoricalData, CurrentSpeedProfile, Alarm }
}
</script>

<style lang="scss" scoped>
.screen-container {
  background-color: #020d1a;
  position: relative;

  .device-no {
    position: absolute;
    left: 60px;
    top: 53px;
    font-family: MyriadPro, MyriadPro;
    font-weight: bold;
    font-size: 24px;
    color: #fcfdfe;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .time {
    position: absolute;
    right: 60px;
    top: 53px;
    font-family: MyriadPro, MyriadPro;
    font-weight: bold;
    font-size: 24px;
    color: #fcfdfe;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .local-time {
    position: absolute;
    right: 60px;
    top: 90px;
    font-family: MyriadPro, MyriadPro;
    font-weight: bold;
    font-size: 24px;
    color: #fcfdfe;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .highlight {
    color: #64a5ff;
  }
}
</style>
